<template>
  <div>
    <div class="d-flex justify-content-between">
      <h1 class="page-header">{{ $t('contentManagement.pageTitle') }}</h1>
      <ts-breadcrumb
        :items="[
          { text: $t('home'), href: '/' },
          {
            text: $t('contentManagement.pageTitle'),
            href: '/content-managements'
          },
          {
            text: $t('create'),
            active: true
          }
        ]"
      />
    </div>
    <ts-card>
      <ts-card-wrapper>
				<ts-loading-banner :loading="loading">
					<div class="row">
						<div class="col-md-3">
							<div class="row">
								<div class="col-md-12">
									<div class="form-group">
										<label class="required">{{ $t('language') }}</label>
										<a-select v-model="model.lang_id" :options="languages" class="ts-w-full"></a-select>
										<div class="validate" v-if="errors.has('lang_id')">{{ errors.first('lang_id') }}</div>
									</div>
								</div>
							</div>
							<div class="row">
								<div class="col-md-12">
									<div class="form-group">
										<label class="required">{{ $t('contentManagement.contentType') }}</label>
										<a-select
											v-model="model.content_type_id"
											:options="content_types"
											class="ts-w-full"
										></a-select>
										<div
											class="validate"
											v-if="errors.has('content_type_id')"
										>{{ errors.first('content_type_id') }}</div>
									</div>
								</div>
							</div>
							<div class="row">
								<div class="col-md-12">
									<div class="form-group">
										<label>
											{{
											$t('contentManagement.shortDescription')
											}}
										</label>
										<textarea v-model.trim="model.short_description" rows="3" class="form-control"></textarea>
										<div
											class="validate"
											v-if="errors.has('short_description')"
										>{{ errors.first('short_description') }}</div>
									</div>
								</div>
							</div>
							<div class="row">
								<div class="col-md-12">
									<div class="form-group">
										<label>{{ $t('contentManagement.thumbnail') }}</label>
										<DropFile
											:placeholder="$t('news.dropThumbnailImage')"
											@file="f => (model.thumbnail_url = f)"
										/>
									</div>
								</div>
							</div>
						</div>
						<div class="col-md-9">
							<label class="required">{{ $t('contentManagement.content') }}</label>
							<VueEditor
								v-model="model.contents"
								:editor-toolbar="customToolbar"
								useCustomImageHandler
								@image-added="handleImageAdded"
							/>
							<div class="validate" v-if="errors.has('contents')">{{ errors.first('contents') }}</div>
						</div>
					</div>
					<div class="row ts-mt-4">
						<div class="col-md-12 text-right ts-space-x-3">
							<ts-button @click.prevent="$router.push({ name: 'content-management' })">{{ $t('cancel') }}</ts-button>
							<ts-button
								color="primary"
								outline
								:waiting="waiting_new"
								@click.prevent="onSaveNew"
							>{{ $t('save_add_new') }}</ts-button>
							<ts-button color="primary" :waiting="waiting" @click.prevent="onSave">{{ $t('save') }}</ts-button>
						</div>
					</div>
				</ts-loading-banner>
      </ts-card-wrapper>
    </ts-card>
  </div>
</template>

<script>
import { VueEditor } from 'vue2-editor'
import { Errors } from 'form-backend-validation'
import DropFile from './components/drop-file'
import { mapActions } from 'vuex'
export default {
  name: 'contentManagementCreate',
  components: {
    DropFile,
    VueEditor
  },
  data() {
    return {
      loading: false,
      waiting: false,
      waiting_new: false,
      errors: new Errors(),
      languages: [],
      content_types: [],
      model: {
        lang_id: null,
        content_type_id: null,
        short_description: null,
        contents: null,
        thumbnail_url: null
      },
      customToolbar: [
        [{ font: [] }],
        [{ header: [false, 1, 2, 3, 4, 5, 6] }],
        ['bold', 'italic', 'underline', 'strike'],
        [
          { align: '' },
          { align: 'center' },
          { align: 'right' },
          { align: 'justify' }
        ],
        [{ header: 1 }, { header: 2 }],
        ['blockquote', 'code-block'],
        [{ list: 'ordered' }, { list: 'bullet' }, { list: 'check' }],
        [{ script: 'sub' }, { script: 'super' }],
        [{ indent: '-1' }, { indent: '+1' }],
        [{ color: [] }, { background: [] }],
        ['link', 'image', 'code-block'],
        [{ direction: 'rtl' }],
        ['clean']
      ]
    }
  },
  created() {
    this.fetchData()
  },
  methods: {
    ...mapActions('administrator/contentManagement', [
      'getLang',
      'store',
      'getContentType'
    ]),
    handleImageAdded(file, Editor, cursorLocation, resetUploader) {
      var formData = new FormData()
      formData.append('file', file)
      formData.append('upload_as', 'content')
      this.$store
        .dispatch('administrator/contentManagement/upload', formData)
        .then(response => {
          Editor.insertEmbed(cursorLocation, 'image', response)
          resetUploader()
        })
        .catch(error => {
          this.$toasted.error(error.message)
        })
    },
    async fetchData() {
      this.loading = true
      await this.getLang().then(response => {
        this.languages = response.data.map(el => ({
          value: el.lang_id,
          label: el.language_name
        }))
      })
      await this.getContentType()
        .then(response => {
          this.content_types = response.data.map(el => ({
            value: el.content_type_id,
            label: el.content_type
          }))
        })
        .catch(error => {
          this.$toasted.error(error.message)
        })
        .finally(() => {
          this.loading = false
        })
    },
    onSave() {
      this.waiting = true
      this.store(this.model)
        .then(response => {
          this.$toasted.success(response.message)
          this.$router.push({ name: 'content-management' })
        })
        .catch(error => {
          this.$toasted.error(error.message)
          this.errors = new Errors(error.errors)
        })
        .finally(() => {
          this.waiting = false
        })
    },
    onSaveNew() {
      this.waiting_new = true
      this.store(this.model)
        .then(response => {
          this.$toasted.success(response.message)
          this.clearInput()
        })
        .catch(error => {
          this.$toasted.error(error.message)
          this.errors = new Errors(error.errors)
        })
        .finally(() => {
          this.waiting_new = false
        })
    },
    clearInput() {
      ;(this.model.lang_id = null), (this.model.content_type_id = null)
      this.model.short_description = null
      this.model.contents = null
      this.model.thumbnail_url = null
    }
  }
}
</script>

<style>
.ql-editor {
  min-height: 23vh !important;
  height: 64vh !important;
  overflow-y: scroll !important;
}
</style>